import Button from 'components/_UI/Button';
import Ilustration from 'components/_UI/Ilustration';
import Text from 'components/_UI/Text';
import React, { useEffect, useState } from 'react'
import { Edit, Edit2, PlusSquare, Trash2 } from 'lucide-react';
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import PermissionsModal from './PermissionsModal';
import collaboratorsApi from 'api/requests/collaborators';
import { useEvent } from 'context/events/Event';
import { FullyCentered } from 'styled/alignment/Center';
import Loader from 'components/_UI/Loader';
import useToast from 'hooks/useToast';
import ToastContainer from 'components/_UI/ToastsContainer';
import Table from 'components/_UI/Table';
import Chips from 'components/_UI/Chips';
import DeletePermissionModal from './DeletePermissionModal';
import InfoTooltip from 'components/_UI/InfoTooltip';
import { BlockContent } from 'styled/UI/BlockContent';

export default function CollaboratorsPermissions() {
    const [modalVisible, setModalVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [content, setContent] = useState(false);
    const [selected, setSelected] = useState(false);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    const { event } = useEvent();
    const { toast, toasts } = useToast();

    useEffect(() => {
        getCollaboratorsPermissions();
    }, []);

    async function getCollaboratorsPermissions() {
        setLoading(true);

        try {
            const { data } = await collaboratorsApi.getList(event?.slug);
            setContent(data?.data);
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    function onSuccess() {
        setModalVisible(false);
        setSelected(false);
        getCollaboratorsPermissions();
        toast.success('Convite enviado com sucesso!', { position: 'top-center' })
    }

    const PANEL_PERMISSION_LABELS = {
        'event.edit': 'Editar evento',
        'event.sales.view': 'Ver pedidos e vendas',
        'participants.view': 'Ver participantes',
    }

    function renderPermissionList(data) {
        if (data === 'ticket') {
            return 'Validar ingressos'
        }

        if (data === 'product') {
            return 'Validar produtos'
        }

        if (data === 'both') {
            return 'Validar ingressos, Validar produtos'
        }
    }

    function renderPanelPermissionList(item) {
        return (item?.permissions || [])
            .map(permission => PANEL_PERMISSION_LABELS[permission])
            .filter(Boolean)
            .join(', ')
    }

    function onEditClick(item) {
        setEdit(item);
        setSelected(item);
        setModalVisible(true);
    }

    function onDeleteClick(item) {
        setSelected(item);
        setDeleteModalVisible(true);
    }

    const renderCollaborators = content.length && content?.map(item => {
        return {
            email: <Text name='small' paddingBottom={0} ellipsisAt={'98%'}>{item?.email}</Text>,
            name: <Column width='auto'>
                <Text name='small' paddingBottom={0}>{renderPermissionList(item?.permission_type)}</Text>
                {
                    renderPanelPermissionList(item) && (
                        <Text name='mini' color={colors.nightLight} paddingBottom={0}>{renderPanelPermissionList(item)}</Text>
                    )
                }
            </Column>,
            // type: <StyledStatus status={item?.status}> {item.type === 'ticket' ? 'Ingresso' : 'Produto'} </StyledStatus>,
            product: <Chips text={item?.status} size={'small'} />,
            actions: <>
                <InfoTooltip
                    text='Editar'
                    type='none'
                >
                    <ActionButton onClick={() => onEditClick(item)} disabled={item?.status === 'rejected'}>
                        <Edit
                            color={item?.status !== 'rejected' ? colors.primary : colors.nightLight}
                            size={18}
                            style={{ marginRight: 10 }}
                        />
                    </ActionButton>
                </InfoTooltip>
                <InfoTooltip
                    text='Excluir'
                    type='none'
                >
                    <ActionButton onClick={() => onDeleteClick(item)}>
                        <Trash2
                            color={colors.danger}
                            size={18}
                        />
                    </ActionButton>
                </InfoTooltip>
            </>,
            // status: <StyledStatus status={item.used}>{item.used ? 'Utilizado' : 'Não Utilizado'}</StyledStatus>

        };
    })

    function onClose() {
        setModalVisible(false);
        setEdit(false);
    }

    function onDeleteModal() {
        setSelected(false);
        setDeleteModalVisible(false);
        getCollaboratorsPermissions();
        toast.success('Permissão excluida com sucesso!', { position: 'top-center' })
    }


    return (
        <Container>
            <ToastContainer toasts={toasts} />
            <HeaderContent>
                <Column width='auto' paddingTop='12px'>
                    <Text name='subtitle' color={colors.nightDark}>
                        Permissões de colaboradores
                    </Text>
                    <Text>
                        Gerencie o acesso e permissões da sua equipe
                    </Text>
                </Column>

                <Button
                    variant='featured'
                    category='squired'
                    onClick={() => setModalVisible(true)}
                >
                    <PlusSquare color={colors.neutralLight} size={16} />
                    <Text
                        color={colors.neutralLight}
                        paddingBottom={0}
                        marginLeft={'6px'}
                    >
                        Convidar colaborador
                    </Text>
                </Button>
            </HeaderContent>

            <BlockContent>


                {
                    modalVisible && (
                        <PermissionsModal
                            visible={modalVisible}
                            edit={edit}
                            onClose={onClose}
                            onSuccess={onSuccess}
                        />
                    )
                }

                {
                    deleteModalVisible && (
                        <DeletePermissionModal
                            visible={deleteModalVisible}
                            data={selected}
                            onClose={() => setDeleteModalVisible(false)}
                            onSuccess={onDeleteModal}
                        />
                    )
                }


                {
                    loading ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        content?.length
                            ? (
                                <>
                                    <Text name='highlight' color={colors.nightDark}>
                                        Equipe do evento
                                    </Text>
                                    <Text marginBottom={'10px'}>
                                        Gerencie os colaboradores e suas permissões de acesso ao evento.
                                    </Text>

                                    <Table
                                        rows={renderCollaborators}
                                        columns={['Colaborador', 'Permissão', 'Status do convite', 'Ações',]}
                                    />
                                </>
                            ) : (
                                <Column fullyCentralized height='auto'>
                                    <Picture>
                                        <Ilustration name='collaboration' />
                                    </Picture>

                                    <Text type='bold' color={colors.night} textAlign={'center'} name='normal' marginTop={'-35px'}>
                                        Você ainda não convidou nenhum colaborador para este evento.
                                    </Text>

                                    <Text type='bold' color={colors.night} textAlign={'center'} name='normal'>
                                        Quel tal convidar?
                                    </Text>

                                    <FullyCentered marginTop='10px'>
                                        <Column width='250px'>
                                            <Button
                                                variant='featured'
                                                category='squired'
                                                onClick={() => setModalVisible(true)}
                                            >
                                                <PlusSquare color={colors.neutralLight} size={16} />
                                                <Text
                                                    color={colors.neutralLight}
                                                    paddingBottom={0}
                                                    marginLeft={'6px'}
                                                >
                                                    Convidar colaborador
                                                </Text>
                                            </Button>
                                        </Column>
                                    </FullyCentered>
                                </Column>
                            )
                    )
                }
            </BlockContent>

        </Container>
    )
}


const Container = styled(Column)`
    width: 100%;
`;

const HeaderContent = styled(Column)`
    width: 100%;
    padding-bottom: 20px;

    & > button {
        margin-top: 10px;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        & > h2,
        & > button {
            width: auto;
            margin-top: 0;
        }

        
    }
`;

const Picture = styled.picture`
    width: auto;
    height: 300px;
`;

const ActionButton = styled.div`
    width: auto;
    height: auto;
    transition: all ease-in-out .25s;
    cursor: pointer;

    ${({ disabled }) => disabled && `
        opacity: .4;
        pointer-events: none;
    `};
`;

const ContentLoader = styled(Column)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;